import { IFilter, ISearch } from '../@lib/models/contracts.models';
import { UserType } from './user-type.model';

// Account ===================================================================================================
export class AccountFilter implements IFilter {
  active: boolean;
  isPayment: number;
  placeTypeId = undefined;
  type;
  allowTravel: boolean;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.isPayment = other.isPayment;
      this.placeTypeId = other.placeTypeId;
      this.type = other.type;
      this.allowTravel = other.allowTravel;
    }
  }
}

export class AccountSearch implements ISearch {
  tradingName: string;
  companyName: string;

  constructor(other?: any) {
    if (other != null) {
      this.tradingName = other.tradingName;
      this.companyName = other.companyName;
    }
  }
}

// Document Type ===================================================================================================
export class DocumentTypeFilter implements IFilter {
  active: boolean;
  legalRepresentative: boolean;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.legalRepresentative = other.legalRepresentative;
    }
  }
}

export class DocumentTypeSearch implements ISearch {
  name: string;
  email: string;
  description: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
      this.email = other.email;
      this.description = other.description;
    }
  }
}

// Event ===================================================================================================
export class EventFilter implements IFilter {
  active: string;
  placeId: string;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.placeId = other.placeId;
    }
  }
}

export class EventSearch implements ISearch {

  constructor(other?: any) {
    if (other != null) {
    }
  }
}

// File ===================================================================================================
export class FileFilter implements IFilter {
  active: boolean;
  // legalRepresentative: boolean;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      //  this.legalRepresentative = other.legalRepresentative;
    }
  }
}

export class FileSearch implements ISearch {
  name: string;
  description: string;
  title: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
      this.description = other.description;
      this.title = other.title;
    }
  }
}

// Health Monitor ===================================================================================================
export class HealthMonitorFilter implements IFilter {
  active: boolean;
  date: string;
  refreshSeconds: number;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.date = other.date;
      this.refreshSeconds = other.refreshSeconds;
    }
  }
}

export class HealthMonitorSearch implements ISearch {

  constructor(other?: any) {
    if (other != null) {
    }
  }
}

// Movement ===================================================================================================
export class MovementFilter implements IFilter {
   guide_number: number;
   dateStart: string;
   dateEnd: string;
   movementTypeIds: Array<string>;
   movementStepIds: Array<string>;
   originId: string;
   destinationId: string;
   active: boolean

  constructor(other?: any) {
    if (other != null) {
      this.movementTypeIds = new Array<string>();
      if (other.movementTypeIds != null && other.movementTypeIds instanceof Array) {
        other.movementTypeIds.forEach((value) => { this.movementTypeIds.push(value); });
      }
      this.movementStepIds = new Array<string>();
      if (other.movementStepIds != null && other.movementStepIds instanceof Array) {
        other.movementStepIds.forEach((value) => { this.movementStepIds.push(value); });
      }
      this.originId = other.originId;
      this.destinationId = other.destinationId;
      this.dateStart = other.dateStart;
      this.dateEnd = other.dateEnd;
      this.guide_number = other.guide_number;
      this.active = other.active;
    }
  }
}

export class MovementSearch implements ISearch {
  movementNumber: string;

  constructor(other?: any) {
    if (other != null) {
      this.movementNumber = other.movementNumber;
    }
  }
}

// Movement Itens Rti ===================================================================================================
export class MovementItemsRtiFilter implements IFilter {
  active: string;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
    }
  }
}

export class MovementItemsRtiSearch implements ISearch {
  movementId: string;
  occurredAt: string;

  constructor(other?: any) {
    if (other != null) {
      this.movementId = other.movementId;
      this.occurredAt = other.occurredAt;
    }
  }
}

// Movement hbgo ===================================================================================================
export class MovementHbgoFilter implements IFilter {
  active: string;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
    }
  }
}

export class MovementHbgoSearch implements ISearch {
  guideNumber: number;

  constructor(other?: any) {
    if (other != null) {
      this.guideNumber = other.guideNumber;
    }
  }
}

// Notifications ===================================================================================================
export class NotificationFilter implements IFilter {
  dateStart: string;
  dateEnd: string;
  type: string;
  userAssignedId: string;
  level: number;
  concluded: boolean;
  priority: boolean;
  deliberation: string;

  constructor(other?: any) {
    if (other != null) {
      this.dateStart = other.dateStart;
      this.dateEnd = other.dateEnd;
      this.type = other.type;
      this.userAssignedId = other.userAssignedId;
      this.level = other.level;
      this.concluded = other.concluded;
      this.priority = other.priority;
      this.deliberation = other.deliberation;
    }
  }
}

export class NotificationSearch implements ISearch {

  constructor(other?: any) {
    if (other != null) {

    }
  }
}

// Pallet Policie ===================================================================================================
export class PalletPolicieFilter implements IFilter {


  constructor(other?: any) {
    if (other != null) {

    }
  }
}

export class PalletPolicieSearch implements ISearch {
  active: boolean;
  placeId: string;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.placeId = other.placeId;
    }
  }
}

// Permission ===================================================================================================
export class PermissionFilter implements IFilter {
  isMenu: boolean;

  constructor(other?: any) {
    if (other != null) {
      this.isMenu = other.isMenu;
    }
  }
}

export class PermissionSearch implements ISearch {
  name: string;
  moduleName: string;
  route: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
      this.moduleName = other.moduleName;
      this.route = other.route;
    }
  }
}

// PermissionScreen ===================================================================================================
export class PermissionScreenFilter implements IFilter {
  active: boolean;
  legalRepresentative: boolean;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.legalRepresentative = other.legalRepresentative;
    }
  }
}

export class PermissionScreenSearch implements ISearch {
  name: string;
  email: string;
  description: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
      this.email = other.email;
      this.description = other.description;
    }
  }
}

// PlaceAccount ===================================================================================================
export class PlaceAccountFilter implements IFilter {
  active: boolean;
  placeTypeId = undefined;
  accountId = undefined;
  justOwnHB = undefined

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.placeTypeId = other.placeTypeId;
      this.accountId = other.accountId;
      this.justOwnHB = other.justOwnHB;
    }
  }
}

// Place ===================================================================================================
export class PlaceFilter implements IFilter {
  active: boolean;
  placeTypeName: string;
  document: string;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.placeTypeName = other.placeTypeName;
      this.document = other.document;
    }
  }
}

export class PlaceSearch implements ISearch {
  tradingName: string;
  placeTypeName: string;
  document: string;

  constructor(other?: any) {
    if (other != null) {
      this.tradingName = other.tradingName;
      this.placeTypeName = other.placeTypeName;
      this.document = other.document;
    }
  }
}

// Places ===================================================================================================
export class PlacesFilter implements IFilter {
  active: boolean;
  placeTypeId: string;
  accountId: string;
  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.placeTypeId = other.placeTypeId;
      this.accountId = other.accountId;
    }
  }
}

export class PlacesSearch implements ISearch {
  tradingName: string;
  companyName: string;

  constructor(other?: any) {
    if (other != null) {
      this.tradingName = other.tradingName;
      this.companyName = other.companyName;
    }
  }
}

// Places Types ===================================================================================================
export class PlaceTypeFilter implements IFilter {
  active: boolean;
  id: string;
  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.id = other.id;
    }
  }
}

export class PlaceTypeSearch implements ISearch {
  name: string;
  description: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
      this.description = other.description;
    }
  }
}

// Products ===================================================================================================
export class ProductsFilter implements IFilter {
  active: boolean;
  name: string;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.name = other.name;
    }
  }
}

export class ProductsSearch implements ISearch {
  name: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
    }
  }
}

// RTI's ===================================================================================================
export class RtiFilter implements IFilter {
  rti_type_id: string;
  rti_status_id: string;

  constructor(other?: any) {
    if (other != null) {
      this.rti_type_id = other.rti_type_id;
      this.rti_status_id = other.rti_status_id;
    }
  }
}

export class RtiSearch implements ISearch {
  code: string;
  gtin: string;

  constructor(other?: any) {
    if (other != null) {
      this.code = other.code;
      this.gtin = other.gtin;
    }
  }
}

// Rti Unit ===================================================================================================
export class RtiUnitFilter implements IFilter {

  constructor(other?: any) {
    if (other != null) {
    }
  }
}

export class RtiUnitSearch implements ISearch {
  rtiUnitNumber: string;

  constructor(other?: any) {
    if (other != null) {
      this.rtiUnitNumber = other.rtiUnitNumber;

    }
  }
}

// Rti Type ===================================================================================================
export class RtiTypeFilter implements IFilter {
  active: boolean;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
    }
  }
}

export class RtiTypeSearch implements ISearch {
  name: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;

    }
  }
}

// Settings ===================================================================================================
export class SettingsFilter implements IFilter {
  active: boolean;
  name: string;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.name = other.name;
    }
  }
}

export class SettingsSearch implements ISearch {
  name: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
    }
  }
}

// Settings System ===================================================================================================
export class SettingsSystemFilter implements IFilter {

  constructor(other?: any) {
    if (other != null) {
    }
  }
}

export class SettingsSystemSearch implements ISearch {

  constructor(other?: any) {
    if (other != null) {
    }
  }
}

// SideMenu ===================================================================================================
export class SideMenuFilter implements IFilter {
  active: boolean;
  name: string;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.name = other.name;
    }
  }
}

export class SideMenuSearch implements ISearch {
  name: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
    }
  }
}

// TypeRTI's ===================================================================================================
export class TypesRtiFilter implements IFilter {
  active: boolean;
  name: string;
  default_pallet_id: string;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.name = other.name;
      this.default_pallet_id = other.default_pallet_id;
    }
  }
}

export class TypesRtiSearch implements ISearch {
  name: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
    }
  }
}

// User Type ===================================================================================================
export class UserTypeFilter implements IFilter {
  active: boolean;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
    }
  }
}

export class UserTypeSearch implements ISearch {
  name: string;
  description: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
      this.description = other.description;
    }
  }
}

// UserTypeMovementType ===================================================================================================
export class UserTypeMovementTypeFilter implements IFilter {
  name: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
    }
  }
}

export class UserTypeMovementTypeSearch implements ISearch {
  name: string;

  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
    }
  }
}

// Users ===================================================================================================
export class UserFilter implements IFilter {
  active: boolean;
  usertype: UserType;
  justOwnHB = undefined;

  constructor(other?: any) {
    if (other != null) {
      this.active = other.active;
      this.usertype = other.usertype;
      this.justOwnHB = other.justOwnHB;
    }
  }
}

export class UserSearch implements ISearch {
  name: string;
  email: string;
  places = [];
  constructor(other?: any) {
    if (other != null) {
      this.name = other.name;
      this.email = other.email;
      this.places = other.places;
    }
  }
}

// UserPlaces ===================================================================================================
export class UserPlacesFilter implements IFilter {
  userId: string;

  constructor(other?: any) {
    if (other != null) {
      this.userId = other.userId;
    }
  }
}

export class UserPlacesSearch implements ISearch {
  tradingName: string;
  companyName: string;
  description: string;

  constructor(other?: any) {
    if (other != null) {
      this.tradingName = other.tradingName;
      this.companyName = other.companyName;
      this.description = other.description;
    }
  }
}

// UserPlaces ===================================================================================================
export class UserPlacesAssignedFilter implements IFilter {
  userId: string;
  placeTypeOriginIds = [];
  placeTypeAssignedIds = [];

  constructor(other?: any) {
    if (other != null) {
      this.userId = other.userId;
      this.placeTypeOriginIds = other.placeTypeOriginIds;
      this.placeTypeAssignedIds = other.placeTypeAssignedIds;
    }
  }
}

export class UserPlacesAssignedSearch implements ISearch {
  tradingName: string;

  constructor(other?: any) {
    if (other != null) {
      this.tradingName = other.tradingName;
    }
  }
}